// Used by:
// - views/layouts/index.jsx              → userAccess (global + vendor: role gating)
// - views/feature/crewPlanner/index.jsx  → userAccess.vendors (activeWorkspaces)
// - views/feature/shoots/index.jsx       → userAccess.vendors (activeWorkspaces)
// - views/feature/HardDrives/index.jsx   → userAccess.vendors (activeWorkspaces)
// - views/feature/Projects/index.jsx     → userAccess.vendors (activeWorkspaces)
// - views/feature/tenantUsers/index.jsx  → userAccess.vendors (activeWorkspaces)
// - views/feature/shootsOverview/index.jsx → userAccess.vendors (activeWorkspaces)
// - views/components/modals/projects/createShoot.jsx → userAccess (global + vendor: crewPlannerUserIds)

const constants = {
	userAccess: {
		global: {
			adminUserIDs: [
				'640ebab69ec47cd24aaeab89', // Gowtham Kasala
				'626d3751c5c41818a3994c97', // Admin Huemn
				'64059c8e4751919e4da559db', // Kore Mahendra
			],
			hrModuleUserIds: [
				'626d3751c5c41818a3994c97', // Admin Huemn
			],
			assetsModuleUserIds: [
				'640ebab69ec47cd24aaeab89', // Gowtham Kasala
				'626d3751c5c41818a3994c97', // Admin Huemn
				'64059c8e4751919e4da559db', // Kore Mahendra
			],
			crewPlannerUserIds: [
				'640ebab69ec47cd24aaeab89', // Gowtham Kasala
				'626d3751c5c41818a3994c97', // Admin Huemn
			],
			adminToolsUserIds: [
				'640ebab69ec47cd24aaeab89', // Gowtham Kasala
				'626d3751c5c41818a3994c97', // Admin Huemn
				'64059c8e4751919e4da559db', // Kore Mahendra
			],
			attendanceExtraUserIds: [],
		},
		vendors: {
			// Photogrphy Equipment Rental Services
			HYD01: {
				activeWorkspaces: [
					{ _id: '5f96f29ae0465a32bbb62de3', workspaceId: 'vijayeesam' }, // VE
					{ _id: '64033bbdd70b3fee271048c9', workspaceId: 'collective' }, // COL
					{ _id: '640f0eda7b6a3c270a5442d8', workspaceId: 'atomcontent' }, // ATOM
					{ _id: '643a47b6a33529516db924ce', workspaceId: 'magnum' }, // MGNM
					// { _id: '62135a6a8c9ad30009186a84', workspaceId: 'loveco' }, // LC
					// { _id: '6389961abca0d5400f377a90', workspaceId: 'magica' }, // MAG
					// { _id: '63972b0481009b48aea5d717', workspaceId: 'dummyhuemn' }, // DH
					// { _id: '626a661476a58400099adc86', workspaceId: 'foreverbygayathri' }, // FBG
					// { _id: '601e6efad4da5d1c534e5a11', workspaceId: 'onelovefilms' }, // OLF
					// { _id: '619ceea937c1100009148f87', workspaceId: 'twobeats' }, // TB
					// { _id: '61e53598619293000915b8c0', workspaceId: 'dreamdaystudios' }, // DDS
					// { _id: '629875436631c600095c0180', workspaceId: 'day1story' }, // D1S
					// { _id: '5fb6139deb051d038ee70222', workspaceId: 'wedberry' }, // WB
					// { _id: '63119c9741fcde00091c36c7', workspaceId: 'bengaluruweddingcompany' }, // BWC
					// { _id: '63bfae01f1c78208178461ad', workspaceId: 'huemnhq' }, // HMNHQ
					// { _id: '628263b7418cb50009314425', workspaceId: 'thedelhiweddingcompany' }, // DWC
					// { _id: '62dd08ea03ff4e00096e1138', workspaceId: 'falaknamafilms' }, // FF
					// { _id: '644bfeb0989fac610ce58004', workspaceId: 'karwaan' }, // KAR
					// { _id: '638c6679f3c2c18509c6fb1f', workspaceId: 'highonlove' }, // HOL
					// { _id: '64b7fa67a822ff2edb58c664', workspaceId: 'rasa' }, // RASA
					// { _id: '61f39aa953b24e0009a4c943', workspaceId: 'houseofikari' }, // HOI
					// { _id: '64c751ada316d136a9f0b667', workspaceId: 'imaazo' }, // IMZO
					// { _id: '64c750e1a316d136a9f0b665', workspaceId: 'studioionic' }, // IONIC
					// { _id: '64c7508105a5dd364e86f9f3', workspaceId: 'madhaniya' }, // MDNIA
					// { _id: '64cb8daf23cca0b3ef7c89ea', workspaceId: 'joystudio' }, // JOYS
					// { _id: '65ae2c78126f35000806e151', workspaceId: 'episodesbysid' }, // EBS
					// { _id: '66965e4e13c2ca95da85392c', workspaceId: 'postx' }, // POSTX
					// { _id: '6217861889a1f600091d6fac', workspaceId: 'balladsoflove' }, // BOL
					// { _id: '6884d37fa6c56df3c8204023', workspaceId: 'arctraditional' }, // ARC
				],
				adminUserIDs: [
					'640ebab69ec47cd24aaeab89', // Gowtham Kasala
					'626d3751c5c41818a3994c97', // Admin Huemn
					'6128dd2f4253cefe5154c52b', // Developer Testing
					'64059c8e4751919e4da559db', // Kore Mahendra
				],
				hrModuleUserIds: [
					'6405ecb2b978f8eb6d970ef1', // Keerthi Sai Sharanya
					'648035443e1921c4c5c574eb', // Chanakya Kambampati
				],
				assetsModuleUserIds: [
					'63fb8b151cced2d24dc9553e', // Panyam Chandra Shekar Reddy
				],
				crewPlannerUserIds: [
					'648035443e1921c4c5c574eb', // Chanakya Kambampati
					'641d829e3f9ca35731464b8f', // Amrutha Boilla
					"6384a5128e31f7db19295a45", // Raghu Ram
				],
				adminToolsUserIds: [
					'63fb8b151cced2d24dc9553e', // Panyam Chandra Shekar Reddy
				],
				attendanceExtraUserIds: [],
			},
			// One Love Films
			OLF: {
				adminUserIDs: [
					'601e6ed7d4da5d1c534e5a10', // Aakanksh Piratla
					'64bfaef74cb5707a2623487b', // Sunil Bhaskar
				],
			},
			// Forever By Gayathri
			FBG: {
				adminUserIDs: [
					'626a65d0ee16b1c1586e3112', // Gayathri
				],
			},
			// High On Love Films
			HOL: {
				adminUserIDs: [
					'64ce91a5aec5091983e7f906', // High On Love Films
				],
			},
			// Wedberry
			WB: {
				adminUserIDs: [
					'5fb60454eb727c03765013b4', // Lokesh Reddy
				],
			},
			// Day One Story
			D1S: {
				adminUserIDs: [
					'629871d2444228bfd19ff359', // Venkat Uppala
				],
			},
			// Episodes By Bharghava
			EBB: {
				adminUserIDs: [
					'61768e9b3579608596ea84c5', // Bharghava Siddagoni
				],
			},
			// The Delhi Wedding Company
			TDWC: {
				adminUserIDs: [
					'6282633d4fdb755ab362b760', // Team TDWC
					'641c0f33763b4a3b079ba857', // Shakti Kumar
				],
			},
			// Bengaluru Wedding Productions
			BWC: {
				adminUserIDs: [
					'631096e5c13f9201e2025ca3', // Bengaluru Wedding Productions
				],
			},
			// Twobeats
			TB: {
				adminUserIDs: [
					'64be23b825c27fd7c754ff91', // Poorna Chandra
				],
			},
			// Ballads of Love Operations
			BOL: {
				adminUserIDs: [
					'621785c224b5330cb2519496', // Ballads of Love
				],
			}
		},
	},
	crewRoles: ['Photographer', 'Cinematographer', 'Editor', 'Drone Operator', 'Assistant'],
	photographyCategories: ['candid', 'traditional'],
	priorities: {
		order: ['high', 'medium', 'low'],
		colors: {
			high: '#FF4D4F',
			medium: '#FAAD14',
			low: '#52C41A',
		},
	},
	taskStatuses: {
		order: ['todo', 'inProgress', 'inReview', 'done'],
		colors: {
			todo: '#8C8C8C',
			inProgress: '#1890FF',
			inReview: '#FAAD14',
			done: '#52C41A',
		},
	},
};

export default constants;
